module.exports = __webpack_public_path__ + "6c4a0dbc/img/saly-icon.39e12342.jpg";